import Vue from 'vue'
import { ToastPlugin, ModalPlugin } from 'bootstrap-vue'
import VueCompositionAPI from '@vue/composition-api'

import router from './router'
import store from './store'
import App from './App.vue'

// Global Components
import './global-components'

// 3rd party plugins
import '@/libs/acl'
import '@/libs/clipboard'
import '@/libs/portal-vue'
import '@/libs/toastification'



// Vuelidate - form validation
import Vuelidate from 'vuelidate';
Vue.use(Vuelidate)


// BSV Plugin Registration
Vue.use(ToastPlugin)
Vue.use(ModalPlugin)

// Composition API
Vue.use(VueCompositionAPI)

// import core styles
require('@core/scss/core.scss')

// import assets styles
require('@/assets/scss/style.scss')

import moment from 'moment';
moment.locale('nl-be');


Vue.config.productionTip = false

import { auth } from '@/firebase/firebaseConfig'

const unsubscribe = auth.onAuthStateChanged((user => {
new Vue({
  router,
  store,
  render: h => h(App),
  created() {
    if (user) {
      user.getIdToken(true);
      this.$store.dispatch('auth/loadUser', {result: {user: user}})
    } else {
      this.$store.dispatch('finishLoading');
    }
}
}).$mount('#app')
 unsubscribe();
}))

